var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVaccinationGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25971_1654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7601 4.73062L26.7795 10.75C27.292 11.2625 27.2964 12.0967 26.7894 12.6037L13.3843 26.0089C12.0475 27.3457 9.86012 27.334 8.50902 25.9829L5.52728 23.0012C4.17618 21.6501 4.16452 19.4627 5.50128 18.1259L18.9064 4.72073C19.4134 4.21369 20.2476 4.21814 20.7601 4.73062Z",
    fill: "url(#paint0_linear_25971_1654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6046 5.21398L25.6484 2.25781L21.7069 6.19936L24.6631 9.15553L28.6046 5.21398Z",
    fill: "#EDEDF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6046 5.21398L25.6484 2.25781L21.7069 6.19936L24.6631 9.15553L28.6046 5.21398Z",
    stroke: "#EDEDF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00202 25.4776L6.03125 23.5068L0.826031 28.7121C0.435507 29.1026 0.435507 29.7357 0.826032 30.1263L1.38259 30.6828C1.77312 31.0734 2.40628 31.0734 2.79681 30.6828L8.00202 25.4776Z",
    fill: "#D2D2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8113 6.83619L15.4219 8.22559L17.7425 10.5462C18.1261 10.9298 18.7482 10.9298 19.1319 10.5462C19.5155 10.1625 19.5155 9.54045 19.1319 9.15678L16.8113 6.83619Z",
    fill: "#91919C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.491 11.1419L11.1016 12.5312L13.4221 14.8518C13.8058 15.2355 14.4279 15.2355 14.8115 14.8518C15.1952 14.4682 15.1952 13.8461 14.8115 13.4624L12.491 11.1419Z",
    fill: "#91919C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17065 15.4573L6.78125 16.8467L9.10184 19.1673C9.48551 19.5509 10.1076 19.5509 10.4912 19.1673C10.8749 18.7836 10.8749 18.1615 10.4912 17.7779L8.17065 15.4573Z",
    fill: "#91919C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.8438,
    y: 0.842773,
    width: 16.7226,
    height: 2.7871,
    rx: 1,
    transform: "rotate(45 18.8438 0.842773)",
    fill: "#D2D2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7756 6.06071L25.2132 1.49837C24.8323 1.11742 24.2146 1.11741 23.8337 1.49836L23.7745 1.55749C23.3936 1.93844 23.3936 2.55608 23.7745 2.93703L28.3369 7.49938C28.7178 7.88033 29.3355 7.88033 29.7164 7.49938L29.7756 7.44025C30.1565 7.0593 30.1565 6.44166 29.7756 6.06071Z",
    fill: "#EDEDF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9432 21.6969H25.96L25.7918 21.3941C25.7918 21.3941 25.775 21.3374 25.7581 21.3185L21.3502 13.333L16.9422 21.2995C16.9422 21.2995 16.9085 21.3563 16.8917 21.3752L16.7234 21.678H16.7403C16.286 22.5674 16 23.5703 16 24.6678C16 27.9793 18.3891 30.6663 21.3333 30.6663C24.2776 30.6663 26.6667 27.9793 26.6667 24.6678C26.6667 23.5703 26.3807 22.5674 25.9264 21.678L25.9432 21.6969Z",
    fill: "#91919C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25971_1654",
    x1: 15.1749,
    y1: 15.8972,
    x2: 15.1081,
    y2: 24.0269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    stopColor: "#EDEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006,
    stopColor: "#DCDCE4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25971_1654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVaccinationGray);
export default __webpack_public_path__ + "static/media/icon-vaccination-gray.336696910fb17561ff397de96bd49395.svg";
export { ForwardRef as ReactComponent };